import { __rest } from "tslib";
import React from 'react';
import Heading from '../Heading';
const HeadingLarge = (_a) => {
    var { Tag = 'h2', children } = _a, props = __rest(_a, ["Tag", "children"]);
    return (React.createElement(Heading, Object.assign({ Tag: Tag, large: true }, props), children));
};
export default HeadingLarge;
//# sourceMappingURL=HeadingLarge.js.map